import { render, staticRenderFns } from "./dd_im.vue?vue&type=template&id=74bd761b&"
import script from "./dd_im.vue?vue&type=script&lang=js&"
export * from "./dd_im.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports